import React from 'react'
import { Menu, Dropdown } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import styles from './style.module.scss'

@injectIntl
class IssuesHistory extends React.Component {
  render() {
    const {
      intl: { formatMessage },
    } = this.props
    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <Link to="/">
            <FormattedMessage id="issuesHistory.currentSearch" />
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/">
            <FormattedMessage id="issuesHistory.searchForIssues" />
          </Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.ItemGroup title={formatMessage({ id: 'issuesHistory.opened' })}>
          <Menu.Item>
            <Link to="/">
              <i className={`${styles.menuIcon} icmn-checkmark`} />
              <FormattedMessage id="issuesHistory.PLAIN4-253" />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/">
              <i className={`${styles.menuIcon} icmn-checkmark`} />
              <FormattedMessage id="issuesHistory.PLAIN4-234" />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/">
              <i className={`${styles.menuIcon} icmn-clock`} />
              <FormattedMessage id="issuesHistory.PLAIN4-424" />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/">
              <FormattedMessage id="issuesHistory.more" />
            </Link>
          </Menu.Item>
        </Menu.ItemGroup>
        <Menu.Divider />
        <Menu.ItemGroup title={formatMessage({ id: 'issuesHistory.filters' })}>
          <Menu.Item>
            <Link to="/">
              <FormattedMessage id="issuesHistory.myOpenIssues" />
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/">
              <FormattedMessage id="issuesHistory.reportedByMe" />
            </Link>
          </Menu.Item>
        </Menu.ItemGroup>
        <Menu.Divider />
        <Menu.Item>
          <Link to="/">
            <i className={`${styles.menuIcon} icmn-cog`} />
            <FormattedMessage id="issuesHistory.settings" />
          </Link>
        </Menu.Item>
      </Menu>
    )
    return (
      <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
        <div className={styles.dropdown}>
          <i className={`${styles.icon} icmn-folder-open`} />
          <span className="d-none d-xl-inline">
            <strong>
              <FormattedMessage id="topBar.issuesHistory" />
            </strong>
          </span>
        </div>
      </Dropdown>
    )
  }
}

export default IssuesHistory
